import React from 'react';
import { useDemo } from '../../contexts/DemoContext';
import { Dialog } from './Dialog';
import { Button } from '../story/Button';
export function SupportDialog() {
  const {
    dialog,
    closeDialog
  } = useDemo();
  return <Dialog open={dialog === 'support'} onClose={closeDialog} id="get-support" title="Get support" data-id="element-485" data-mp="23m1539llg5kx">
      <div className="flex flex-col gap-3" data-id="element-486" data-mp="1ypan2gq8azwv">
        <p data-id="element-487" data-mp="1yqc18u2jk2it">This demo is not monitored.</p>
        <p data-id="element-488" data-mp="1axlsetpxpzcr">If you need help, reach a trusted adult or a local support service.</p>
        <p className="font-bold text-forest" data-id="element-489" data-mp="15ztxdqtztx4c">If someone is in immediate danger, contact local emergency services.</p>
        <p data-id="element-490" data-mp="1k04q6zev5ls5">Your school, community, or platform may have a reporting route.</p>
      </div>
      <div className="mt-6 flex justify-end" data-id="element-491" data-mp="1fx8elsnqqpxp">
        <Button variant="secondary" onClick={closeDialog} data-id="element-492" data-mp="1fw6tevd0gn29">
          Back to the story
        </Button>
      </div>
    </Dialog>;
}